import React, { useEffect } from "react";
import CustomCheckbox from "./CustomCheckbox";
import { SET_DISABLE_FRACTION, SET_DISABLE_FRACTION_RENT} from "../../../../actions/create-bot-type";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { disableFractionExchanges } from "../../../../utils/Utils";
import LeftRightForm from "./LeftRightForm";

const DisableFractionalPurchase = (props)=>{
    const {rent, leftCol,rightCol} = props
    const newBot = useSelector((state) => state.createBot.newBot);
    const rentBot = useSelector((state) => state.createBot.rentBot);
    const {t} = useTranslation()
    const selectedExchange = rent ? rentBot.exchange : newBot.exchange;
    const disableFractionPurchaseRent =isNaN(rentBot.disableFractionPurchase)?0:parseInt(rentBot.disableFractionPurchase);
    const disableFractionPurchase =isNaN(newBot.disableFractionPurchase)?0:parseInt(newBot.disableFractionPurchase);
    const dispatch = useDispatch()
    const forceDisableFractionExchangeIds = [14, 140];

    const forcedDisableFraction = forceDisableFractionExchangeIds.includes(Number(selectedExchange?.id));
    const checkedValue = forcedDisableFraction
      ? 1
      : (rent ? disableFractionPurchaseRent : disableFractionPurchase);

    const setDisableFraction = (val) => {
        dispatch({
          type: rent?SET_DISABLE_FRACTION_RENT:SET_DISABLE_FRACTION,
          payload: val?1:0,
        });
      };

    useEffect(() => {
        if (forcedDisableFraction && checkedValue) {
          setDisableFraction(true);
        }
    }, [forcedDisableFraction, checkedValue]);

    return(<>
        {disableFractionExchanges(selectedExchange) && 
        
            <LeftRightForm 
            left={<></>}
            right={ <CustomCheckbox 
                val={checkedValue} 
                checked={checkedValue} 
                callback={(val) => {
                  if (forcedDisableFraction) {
                    setDisableFraction(true);
                    return;
                  }
                  setDisableFraction(val);
                }}
                label={t("dis-frac-purchase")}
                id={'dis-frac-purchase'}
                >
                </CustomCheckbox>}
                 leftCol={leftCol}
             rightCol={rightCol}
            >
            </LeftRightForm>
        
           }
    </>)
}

export default DisableFractionalPurchase;
